<template>
    <div class="home">
        <v-header></v-header>
        <v-headers></v-headers>
        <section class="top">
            <!-- bg -->
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <div class="hoverNav"></div>
            <picture>
                <source
                    class="bg"
                    srcset="../assets/images/mobile/bg_mobile.jpg"
                    media="(max-width: 600px)"
                />
                <img
                    class="bg"
                    :src="bgurl"
                    style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);transition: all 3s;"
                />
            </picture>

            <!-- slogan -->
            <picture>
                <source
                    class="slogan"
                    srcset="../assets/images/mobile/slogan_mobile.png"
                    media="(max-width: 600px)"
                />
                <img class="slogan" src="../assets/images/slogan.png" />
            </picture>

            <!-- btn -->
            <div class="startGame">
                <img src="../assets/images/btn_startgame.png" alt />
                <!-- <img src="../assets/images/btn_startgame_disable.png" alt> -->
                <!-- <div class="disable"></div> -->
                <a class="clickArea" href="javascript:void(0);" @click="startGame"></a>
            </div>
            <div class="tournament_startgame">
                <img src="../assets/images/tournament_startgame.png" alt />
                <a class="clickArea" href="https://tournament.mahjongsoul.com/dhs-dmm/index.html"></a>
            </div>
            <div class="playvideo">
                <i class="icon_playvideo iconfont icon-iconbofang" @click="playvideo"></i>
            </div>

            <img class="img_s" src="../assets/images/Mahjong_logo.1.png" alt />

            <!-- kanban -->
            <transition-group
                class="kanban_container"
                :enter-class="kanban_box_enterClass"
                enter-active-class="kanban-active"
                leave-active-class="kanban-active"
                :leave-to-class="kanban_box_leaveClass"
                tag="ul"
            >
                <li
                    class="kanban_box"
                    v-show="index === curkanban_index"
                    v-for="(imgAttr, index) in kanbanList"
                    :key="index"
                >
                    <img
                        v-if="lzIndex.indexOf(index) !== -1"
                        :src="imgAttr.imgUrl"
                        :style="imgAttr.imgCss"
                        ondragstart="return false;"
                        alt
                        @click="chatMask(index)"
                    />
                    <!-- @mousedown="move"
                    @touchstart="move"-->
                </li>
            </transition-group>
            <i class="next_btn" @click="toggle('next')"></i>
            <i class="pre_btn" @click="toggle('pre')"></i>
            <div class="touch_tip" v-if="touch_tip_show"></div>
            <!-- 语音 -->
            <audio
                ref="audio"
                :src="chat_audio"
                @canplay="audio_playing = true"
                @playing="audio_playing = true"
                @pause="audio_playing = false"
                @ended="audio_playing = false"
            ></audio>

            <!-- mask -->
            <!-- video -->
            <div class="video_mask" v-if="video_show">
                <div class="iframe">
                    <iframe
                        width="1120"
                        height="630"
                        :src="videoUrl"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen
                    ></iframe>
                    <div class="close_btn" @click="close_video"></div>
                </div>
            </div>
            <!-- chat -->
            <transition name="chatMask_fade">
                <div class="chat_mask" v-show="chat_msg">
                    <p>{{ chat_msg }}</p>
                    <img
                        v-show="audio_playing"
                        class="audioPlay"
                        ondragstart="return false;"
                        src="../assets/images/audio_play.gif"
                        alt
                    />
                </div>
            </transition>
        </section>
        <!-- stayTuned -->

        <v-footer></v-footer>
    </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/dmmheader.vue";
import Headers from "@/components/dmmnavi_header.vue";

export default {
    name: "home",
    components: {
        "v-footer": Footer,
        "v-header": Header,
        "v-headers": Headers
    },
    data: () => ({
        // bgUrl
        bgurl: require("../assets/images/bg.jpg"),
        // kanban
        kanbanList: [
            {
                imgUrl: require("../assets/images/kanban/kanban01.png"),
                imgCss: {
                    width: "100%",
                    left: "4%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg: "ちーっす！私は一姫にゃ！よろしくにゃん！",
                        audio: require("../assets/audio/01/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "にゃ～～…は～お菓子って、なぜか人からもらった方がおいしく感じるにゃー　もっとほしいにゃー",
                        audio: require("../assets/audio/01/lobby_normal5.mp3")
                    },
                    {
                        msg:
                            "猫の耳はとーってもデリケートにゃ！気安く触さわるもんじゃにゃいにゃ！　…ン～コホン…でご主人？　ちょっと触ってみるにゃ？",
                        audio: require("../assets/audio/01/lobby_normal7.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban02.png"),
                imgCss: {
                    width: "90%",
                    bottom: "0%",
                    left: "8%"
                },
                chat: [
                    {
                        msg: "二階堂美樹です、よろしくお願いします～",
                        audio: require("../assets/audio/02/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "麻雀で私に勝てたら、ちょっぴりサプライズなご褒美…あげちゃおうかなぁ～",
                        audio: require("../assets/audio/02/lobby_normal2.mp3")
                    },
                    {
                        msg:
                            "麻雀って楽しいわ、でも、好きな人と打つと、もっと楽しくなるわ",
                        audio: require("../assets/audio/02/lobby_normal3.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban03.png"),
                imgCss: {
                    width: "88%",
                    right: "0%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg: "撫子だ、よろしく！",
                        audio: require("../assets/audio/03/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "敗けて落ち込む時間があるなら、次の対局でかっこよく勝つために努力するってのは、どうだい？",
                        audio: require("../assets/audio/03/lobby_normal3.mp3")
                    },
                    {
                        msg:
                            "ビール飲むかい？…酒のない人生なんて、つまんないよ？（酒を飲むアドリブ）……ぷはーんん～～",
                        audio: require("../assets/audio/03/lobby_normal5.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban04.png"),
                imgCss: {
                    width: "65%",
                    left: "25%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg: "いえーい！トップアイドルの佳奈ちゃんでーす！",
                        audio: require("../assets/audio/04/game_top.mp3")
                    },
                    {
                        msg:
                            "今日はいい天気だね！ひきこも…じゃなくて、仕事にもってこいのお天気だー！",
                        audio: require("../assets/audio/04/lobby_normal2.mp3")
                    },
                    {
                        msg:
                            "アイドルの悩み？んー仕事のせいでゲームする時間がなくなっちゃう事くらいかなぁ？",
                        audio: require("../assets/audio/04/lobby_normal4.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban05.png"),
                imgCss: {
                    width: "92%",
                    left: "6%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg:
                            "わたくしは九条璃雨、ご覧の通りメイドをしております…あまりジロジロ見ないでください",
                        audio: require("../assets/audio/05/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "これはここに…、それはあっちに…次、またこんなミスをしたら、殴りますよ？",
                        audio: require("../assets/audio/05/lobby_normal1.mp3")
                    },
                    {
                        msg:
                            "チッ、どうやったら部屋をここまで散らかせるんですか？早く起きなさい、床は私に任せて…あなたは机の上をお片付けください。い・ま・す・ぐ・に！",
                        audio: require("../assets/audio/05/lobby_normal4.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban06.png"),
                imgCss: {
                    width: "85%",
                    left: "10%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg:
                            "ふーん、あんたが新しい雀士なの？…貧相な顔ねぇ、まぁ、せいぜい千織の足を引っ張らないでよね",
                        audio: require("../assets/audio/06/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "なによ、ジロジロ見て、エッチなことでも考えてるの？？",
                        audio: require("../assets/audio/06/lobby_normal2.mp3")
                    },
                    {
                        msg:
                            "バカ！変態！アホー！！…え、怒らないの？変な人ね。",
                        audio: require("../assets/audio/06/lobby_normal3.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban07.png"),
                imgCss: {
                    width: "64%",
                    left: "23%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg: "…八木唯よ、あなたは…？",
                        audio: require("../assets/audio/07/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "どうして他のみんなはあんなに表情が豊かなの？…理解できない",
                        audio: require("../assets/audio/07/lobby_normal2.mp3")
                    },
                    {
                        msg:
                            "先輩、先輩、先輩、先輩…先輩って面白いね、言い方を変えただけでこんなに意味が変わるなんて",
                        audio: require("../assets/audio/07/lobby_normal4.mp3")
                    }
                ]
            },
            {
                imgUrl: require("../assets/images/kanban/kanban08.png"),
                imgCss: {
                    width: "52%",
                    left: "24%",
                    bottom: "0%"
                },
                chat: [
                    {
                        msg: "は、始めまして…ど、どうぞよろしくお願いします…",
                        audio: require("../assets/audio/08/lobby_selfintro.mp3")
                    },
                    {
                        msg:
                            "魔法マージャン？　霊力マージャンしか聞いたことありませんが…もし霊力を補充したいお客様がいらっしゃるのなら、この舞が…",
                        audio: require("../assets/audio/08/lobby_normal2.mp3")
                    },
                    {
                        msg:
                            "えっと…旦那様、あまり…見ないでください…恥ずかしいです…",
                        audio: require("../assets/audio/08/lobby_normal6.mp3")
                    }
                ]
            }
        ],
        curkanban_index: 0,
        curkanban_dir: "",
        audio_playing: false,
        lzIndex: [0, 1, 7],
        // vide0
        video_show: false,
        videoUrl: "https://www.youtube.com/embed/qnmV7kusMIs",
        // chat_mask
        chat_msg: "",
        chat_audio: "",
        // stayTuned
        channelList: [
            {
                iconUrl: require("../assets/images/staytuned/tw_icon.png"),
                text: "Twitter",
                href: "https://twitter.com/MahjongSoul_JP"
            },
            {
                iconUrl: require("../assets/images/staytuned/youtube_icon.png"),
                text: "Youtube",
                href: "https://www.youtube.com/channel/UC8Wn_3U-fssptm6US_nsoOA"
            },
            {
                iconUrl: require("../assets/images/staytuned/discord_icon.png"),
                text: "Discord",
                href: "https://discord.gg/PDn4AaT"
            }
        ]
    }),
    created() {
    },
    methods: {
        startGame() {
            window.location.href = "https://dmc.mahjongsoul.com/dmm/index.html"
            // this.axios.get("/config").then(v=> {
            //     if(v.retcode == 2000) {
            //         window.location.href = `${process.env.VUE_APP_BASEURL}?p=${v.data.p}`
            //     } else {
            //         console.log("get config error")
            //     }
            // }).then(e => {
            //     console.log(e)
            // })
        },
        csoonShow() {
            alert("Coming Soon!");
        },
        toggle(dir) {
            // 开始加载全部看板娘
            this.lzIndex = [0, 1, 2, 3, 4, 5, 6, 7];

            this.curkanban_dir = dir;
            this.chat_msg = ""; // 切换时，清除chat_mask
            this.$refs.audio.pause(); // 停止播放语音
            this.$refs.audio.currentTime = 0;

            if (dir === "next") {
                this.curkanban_index =
                    (this.curkanban_index + 1) % this.kanbanList.length;
            } else if (dir === "pre") {
                if (this.curkanban_index <= 0) {
                    this.curkanban_index = this.kanbanList.length - 1;
                } else {
                    this.curkanban_index -= 1;
                }
            }
        },
        playvideo() {
            this.video_show = true;
            this.$utils.hidde_scrollbar();
        },
        close_video() {
            this.video_show = false;
            this.$utils.show_scrollbar();
        },
        chatMask(index) {
            // 隐藏touch按钮
            this.$store.commit("SET_TOUCH_TIP_SHOW", false);

            let flag = this.rand(this.kanbanList[index].chat.length);
            this.chat_msg = this.kanbanList[index].chat[flag].msg;
            //  播放语音
            this.chat_audio = this.kanbanList[index].chat[flag].audio;
            this.$refs.audio.addEventListener("loadedmetadata", () => {
                this.$refs.audio.volume = 0.5;
                this.$refs.audio.play();
            });
        },
        rand(n) {
            return Math.floor(Math.random() * n);
        },
        move(e) {
            if (e.touches) {
                // 触摸事件对象
                e = e.touches[0];
            }

            let oimg = e.target;
            let oW = oimg.offsetWidth; // 当前图片宽度
            let disX = e.clientX; // 当前鼠标在浏览器中x坐标
            let left;

            // 移动端触摸事件
            oimg.ontouchmove = e => {
                left = e.touches[0].clientX - disX; // 鼠标在x轴移动距离

                oimg.style.transform = `translateX(${left}px)`;
                oimg.style.opacity = `${1 - Math.abs(left / (oW / 4))}`;
            };
            oimg.ontouchend = e => {
                if (Math.abs(left) > oW / 8 && Math.abs(left) < oW) {
                    // 到达切换条件
                    this.chat_msg = ""; // 切换时，清除chat_mask
                    if (left > 0) {
                        this.curkanban_index =
                            (this.curkanban_index + 1) % this.kanbanList.length;
                    } else {
                        if (this.curkanban_index <= 0) {
                            this.curkanban_index = this.kanbanList.length - 1;
                        } else {
                            this.curkanban_index -= 1;
                        }
                    }
                    // 清除样式
                    setTimeout(() => {
                        oimg.style.opacity = 1;
                        oimg.style.transform = "translateX(0px)";
                    }, 1000); // 定时时间和图片切换过度时间保持一致
                } else {
                    // 未达到切换条件
                    oimg.style.opacity = 1;
                    oimg.style.transform = "translateX(0px)";
                }
            };
            // pc端拖拽事件
            document.onmousemove = e => {
                left = e.clientX - disX; // 鼠标在x轴移动距离

                oimg.style.transform = `translateX(${left}px)`;
                oimg.style.opacity = `${1 - Math.abs(left / (oW / 4))}`;
            };
            document.onmouseup = e => {
                if (Math.abs(left) > oW / 8) {
                    // 到达切换条件
                    this.chat_msg = ""; // 切换时，清除chat_mask
                    if (left > 0) {
                        this.curkanban_dir = "next";
                        this.curkanban_index =
                            (this.curkanban_index + 1) % this.kanbanList.length;
                    } else {
                        this.curkanban_dir = "pre";
                        if (this.curkanban_index <= 0) {
                            this.curkanban_index = this.kanbanList.length - 1;
                        } else {
                            this.curkanban_index -= 1;
                        }
                    }
                    // 清除样式
                    setTimeout(() => {
                        oimg.style.opacity = 1;
                        oimg.style.transform = "translateX(0px)";
                    }, 1000); // 定时时间和图片切换过度时间保持一致
                } else {
                    // 未达到切换条件
                    oimg.style.opacity = 1;
                    oimg.style.transform = "translateX(0px)";
                }
                // 注销事件
                document.onmousemove = null;
                document.onmouseup = null;
            };
        },
        /* jumpToPre() {
            this.$router.push({ path: "/pre_registration" });
        } */
    },
    computed: {
        kanban_box_enterClass() {
            return `${
                this.curkanban_dir === "next"
                    ? "kanban_next-enter"
                    : "kanban_pre-enter"
            }`;
        },
        kanban_box_leaveClass() {
            return `${
                this.curkanban_dir === "next"
                    ? "kanban_next-leave-to"
                    : "kanban_pre-leave-to"
            }`;
        },
        touch_tip_show() {
            return this.$store.state.TOUCH_TIP_SHOW;
        }
    }
};
</script>

<style lang="scss" scoped>
.top {
    width: 100%;
    height: 23.57692rem;
    /*padding-top: 47.6%;*/
    position: relative;
    overflow: hidden;

    @media screen and (max-width: 600px) {
        height: pxTorem(780px);
    }

    .hoverNav {
        position: absolute;
        z-index: 1;

        width: calc(100% / 3);
        height: calc(100% / 3);

        @media screen and (max-width: 600px) {
            display: none;
        }

        &:nth-of-type(1) {
            top: 0;
            left: 0;

            &:hover ~ picture > .bg {
                transform: translate(-49%, -49%) !important;
            }
        }

        &:nth-of-type(2) {
            top: 0;
            left: calc(100% / 3);

            &:hover ~ picture > .bg {
                transform: translate(-50%, -49%) !important;
            }
        }

        &:nth-of-type(3) {
            top: 0;
            left: calc(100% / 3 * 2);

            &:hover ~ picture > .bg {
                transform: translate(-51%, -49%) !important;
            }
        }

        &:nth-of-type(4) {
            top: calc(100% / 3);
            left: 0;

            &:hover ~ picture > .bg {
                transform: translate(-49%, -50%) !important;
            }
        }

        &:nth-of-type(5) {
            top: calc(100% / 3);
            left: calc(100% / 3);
        }

        &:nth-of-type(6) {
            top: calc(100% / 3);
            left: calc(100% / 3 * 2);

            &:hover ~ picture > .bg {
                transform: translate(-51%, -50%) !important;
            }
        }

        &:nth-of-type(7) {
            top: calc(100% / 3 * 2);
            left: 0;

            &:hover ~ picture > .bg {
                transform: translate(-49%, -51%) !important;
            }
        }

        &:nth-of-type(8) {
            top: calc(100% / 3 * 2);
            left: calc(100% / 3);

            &:hover ~ picture > .bg {
                transform: translate(-50%, -51%) !important;
            }
        }

        &:nth-of-type(9) {
            top: calc(100% / 3 * 2);
            left: calc(100% / 3 * 2);

            &:hover ~ picture > .bg {
                transform: translate(-51%, -51%) !important;
            }
        }
    }

    .bg {
        display: block;
        width: 102%;
        z-index: 0;
        @media screen and (max-width: 600px) {
            width: 100%;
        }
    }

    .slogan {
        position: absolute;
        top: pxTorem(114px);
        left: pxTorem(190px);
        width: pxTorem(567px);
        @media screen and (max-width: 600px) {
            width: MpxTorem(274px);
            top: MpxTorem(365px);
            left: 50%;
            transform: translateX(-50%);
            display: none;
        }
    }

    .startGame {
        position: absolute;
        width: pxTorem(446px);
        top: pxTorem(350px);
        left: pxTorem(233px);
        z-index: 3;

        @media screen and (max-width: 600px) {
            width: MpxTorem(350px);
            top: MpxTorem(300px);
            left: 50%;
            transform: translateX(-50.6%);
        }

        img {
            display: block;
            width: 100%;
        }

        .disable {
            content: "";
            display: block;
            position: absolute;
            width: pxTorem(400px);
            height: pxTorem(159.5px);
            background: url("../assets/images/btn_startgame_icon.png") no-repeat
                center/100%;
            left: pxTorem(-83px);
            top: pxTorem(-70px);
            z-index: 3;
        }

        .clickArea {
            display: block;
            width: pxTorem(311px);
            height: pxTorem(74px);
            position: absolute;
            z-index: 4;
            left: pxTorem(70px);
            top: pxTorem(8px);
            cursor: pointer;
            @media screen and (max-width: 600px) {
                width: MpxTorem(246px);
                height: MpxTorem(60px);
                top: MpxTorem(5px);
                left: MpxTorem(54px);
            }
        }
    }
    .tournament_startgame {
        position: absolute;
        width: pxTorem(446px);
        top: pxTorem(450px);
        left: pxTorem(233px);
        z-index: 3;

        @media screen and (max-width: 600px) {
            width: MpxTorem(350px);
            top: MpxTorem(380px);
            left: 50%;
            transform: translateX(-50.6%);
        }

        img {
            display: block;
            width: 100%;
        }

        .disable {
            content: "";
            display: block;
            position: absolute;
            width: pxTorem(400px);
            height: pxTorem(159.5px);
            background: url("../assets/images/btn_startgame_icon.png") no-repeat
                center/100%;
            left: pxTorem(-83px);
            top: pxTorem(-70px);
            z-index: 3;
        }

        .clickArea {
            display: block;
            width: pxTorem(311px);
            height: pxTorem(74px);
            position: absolute;
            z-index: 4;
            left: pxTorem(70px);
            top: pxTorem(8px);
            cursor: pointer;
            @media screen and (max-width: 600px) {
                width: MpxTorem(246px);
                height: MpxTorem(60px);
                top: MpxTorem(5px);
                left: MpxTorem(54px);
            }
        }
    }

    .pre_reg_btn {
        position: absolute;
        width: pxTorem(332px);
        top: pxTorem(453px);
        left: pxTorem(293px);
        z-index: 3;
        cursor: pointer;

        @media screen and (max-width: 600px) {
            width: MpxTorem(244px);
            top: MpxTorem(500px);
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .btn_Download_box {
        position: absolute;
        width: pxTorem(318px);
        height: pxTorem(52px);
        top: pxTorem(530px);
        left: pxTorem(300px);
        z-index: 4;

        @media screen and (max-width: 600px) {
            width: MpxTorem(245px);
            height: MpxTorem(39px);
            top: MpxTorem(572px);
            left: 50%;
            transform: translateX(-50%);
        }

        .btn_iosDownload {
            position: absolute;
            display: block;
            width: pxTorem(141px);
            height: 100%;
            left: 0;
            top: 0;
            background: url("../assets/images/ios_download_button.png")
                no-repeat;
            background-size: 100%;
            @media screen and (max-width: 600px) {
                width: MpxTorem(106px);
            }
        }

        .btn_androidDownload {
            position: absolute;
            display: block;
            width: pxTorem(174px);
            height: 100%;
            top: 0;
            right: 0;
            background: url("../assets/images/android_download_button.png")
                no-repeat;
            background-size: 100%;
            @media screen and (max-width: 600px) {
                width: MpxTorem(130px);
            }
        }

        .download_tip {
            position: absolute;
            width: pxTorem(100px);
            right: 105%;
            bottom: 90%;
            animation: 1s breathe infinite;

            @keyframes breathe {
                0% {
                    transform: scale(1) translateZ(0);
                }
                50% {
                    transform: scale(1.05) translateZ(0);
                }
                100% {
                    transform: scale(1) translateZ(0);
                }
            }
            @media screen and (max-width: 600px) {
                width: MpxTorem(55px);
                right: 100%;
            }
        }
    }

    .playvideo {
        position: absolute;
        z-index: 5;
        width: pxTorem(58px);
        height: pxTorem(219px);
        left: pxTorem(718px);
        top: pxTorem(36px);
        background: url("../assets/images/btn_playvideo.png") no-repeat;
        background-size: 100%;

        @media screen and (max-width: 600px) {
            width: MpxTorem(46px);
            height: MpxTorem(160px);
            left: MpxTorem(161px);
            top: MpxTorem(50px);
        }

        .icon_playvideo {
            position: absolute;
            top: pxTorem(65px);
            left: pxTorem(9px);
            font-size: pxTorem(30px);
            color: #fff;
            border-radius: 48%;
            line-height: 1;
            cursor: pointer;
            box-shadow: 0 0 18px 2px rgba(255, 43, 218, 0.48),
                0 0 20px 7px rgba(255, 43, 218, 0.48) inset;
            transition: color 1s;

            @media screen and (max-width: 600px) {
                left: MpxTorem(9px);
                top: MpxTorem(57px);
            }

            &:hover {
                color: rgba(255, 43, 218, 0.48);
            }
        }
    }

    .img_s {
        position: absolute;
        top: pxTorem(18px);
        left: pxTorem(39px);
        @media screen and (max-width: 600px) {
            width: pxTorem(120px);
            left: pxTorem(12px);
        }
    }

    .kanban_container {
        position: absolute;
        z-index: 4;
        width: pxTorem(680px);
        height: pxTorem(532px);
        right: 0;
        bottom: 0;
        // border: 1px solid lightcoral;
        @media screen and (max-width: 600px) {
            display: none;
        }

        .kanban-active {
            transition: all 1s ease;
        }

        .kanban_next-enter {
            opacity: 0;
            transform: translateX(-50%);
        }

        .kanban_next-leave-to {
            opacity: 0;
            transform: translateX(50%);
        }

        .kanban_pre-enter {
            opacity: 0;
            transform: translateX(50%);
        }

        .kanban_pre-leave-to {
            opacity: 0;
            transform: translateX(-50%);
        }

        .kanban_box {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            top: 0;
            left: 0;

            img {
                display: block;
                position: absolute;
                width: 100%;
                cursor: pointer;
            }
        }
    }

    .next_btn {
        width: pxTorem(50px);
        height: pxTorem(50px);
        background: url("../assets/images/V.png") no-repeat;
        background-size: cover;
        position: absolute;
        font-size: pxTorem(40px);
        top: pxTorem(444px);
        right: pxTorem(30px);
        z-index: 5;
        cursor: pointer;
        transition: color 0.3s;
        color: #fff;

        @media screen and (max-width: 600px) {
            display: none;
        }
    }

    .next_btn:hover {
        background: url("../assets/images/next_btn_active.png") no-repeat
            pxTorem(7px) pxTorem(7px);
    }

    .pre_btn {
        width: pxTorem(50px);
        height: pxTorem(50px);
        background: url("../assets/images/V.png");
        position: absolute;
        font-size: pxTorem(40px);
        top: pxTorem(444px);
        left: pxTorem(720px);
        z-index: 5;
        background-size: 100%;
        transform: scaleX(-1);
        cursor: pointer;
        transition: color 0.3s;
        color: #fff;

        @media screen and (max-width: 600px) {
            display: none;
        }
    }

    .pre_btn:hover {
        background: url("../assets/images/next_btn_active.png") no-repeat
            pxTorem(7px) pxTorem(7px);
    }

    .touch_tip {
        position: absolute;
        top: pxTorem(515px);
        right: pxTorem(97px);
        z-index: 5;
        width: pxTorem(90px);
        height: pxTorem(55px);
        background: url("../assets/images/touch.png") no-repeat;
        background-size: 100%;
        animation: 1s breathe infinite;

        @media screen and (max-width: 600px) {
            display: none;
        }

        @keyframes breathe {
            0% {
                transform: scale(1);
            }
            50% {
                transform: scale(1.05);
            }
            100% {
                transform: scale(1);
            }
        }
    }

    // mask
    .video_mask {
        width: 100vw;
        height: 100vh;
        background: #000a21a1;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;

        .iframe {
            width: 70%;
            height: 0;
            padding-top: 39.375%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            background: #000;

            @media screen and (max-width: 600px) {
                width: 90%;
                padding-top: 50.625%;
            }

            iframe {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
            }

            .close_btn {
                width: pxTorem(50px);
                height: pxTorem(125px);
                position: absolute;
                right: pxTorem(-70px);
                top: pxTorem(8px);
                background: url("../assets/images/faq_closeBtn.png") no-repeat;
                background-size: 100%;
                cursor: pointer;

                @media screen and (max-width: 600px) {
                    width: MpxTorem(50px);
                    height: MpxTorem(125px);
                    right: MpxTorem(-22px);
                    top: MpxTorem(-20px);
                }
            }
        }
    }

    .chat_mask {
        position: absolute;
        width: pxTorem(300px);
        height: pxTorem(105px);
        background: #2f284ead;
        right: pxTorem(165px);
        bottom: pxTorem(50px);
        z-index: 5;
        box-sizing: border-box;
        border-radius: 8px;
        padding: pxTorem(10px) pxTorem(15px);
        color: #cecece;
        font-size: pxTorem(15px);
        line-height: 1.1;
        font-family: "MaruFoPro";

        @media screen and (max-width: 600px) {
            display: none;
        }

        .audioPlay {
            width: pxTorem(20px);
            height: pxTorem(20px);
            position: absolute;
            right: pxTorem(15px);
            bottom: pxTorem(10px);
        }
    }

    .chatMask_fade-enter-active,
    .chatMask_fade-leave-active {
        transition: opacity 0.5s;
    }

    .chatMask_fade-enter,
    .chatMask_fade-leave-to {
        opacity: 0;
    }
}

.stayTuned {
    width: 100%;
    height: pxTorem(94px);
    background: #000a21;

    @media screen and (max-width: 600px) {
        height: MpxTorem(108px);
    }

    .content {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        line-height: pxTorem(94px);
        text-align: center;
        @media screen and (max-width: 600px) {
            line-height: MpxTorem(108px);
        }

        .logo {
            display: inline-block;
            width: pxTorem(123px);
            margin: 0 pxTorem(50px) 0 0;
            @media screen and (max-width: 600px) {
                display: none;
            }
        }

        .channel {
            display: inline-block;
            width: pxTorem(27px);
            height: pxTorem(44px);
            position: relative;
            line-height: 1.5;
            margin: 0 pxTorem(15px);

            @media screen and (max-width: 600px) {
                width: MpxTorem(34px);
                height: MpxTorem(50px);
                margin: 0 MpxTorem(10px);
                vertical-align: middle;
            }
            @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait),
                (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                margin: 0 pxTorem(32px);
            }

            img {
                display: inline-block;
                width: 100%;
                vertical-align: top;
            }

            .text {
                font-size: pxTorem(10px);
                position: absolute;
                bottom: -5%;
                left: 50%;
                transform: translateX(-50%);
                color: #fff;
                @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait),
                    (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                    bottom: -15%;
                }
                @media screen and (max-width: 600px) {
                    font-size: MpxTorem(9px);
                }
            }
        }
    }
}
</style>
